import React, { useEffect, useState } from 'react';
import Detail from './../../../pages/detail/detail';
import { tableFormat } from '../../../../config/tableFormat';
import { useDispatch, useSelector } from 'react-redux';
import Draggable from './Draggable';
import "./tablecomponant.css"
import "./mastertable.css"
import { handleManualAllocation, updateAllManagedTableData } from '../../../../redux/reducers/rootReducer';

const AddComponent = (props) => {

    const [errorRow, setErrorRow] = React.useState({});
    const dispatch = useDispatch();

    const [selectedRows, setSelectedRows] = useState(props.selectedIndex || []);
    const [showBackDrop, setShowBackDrop] = React.useState(false);
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const [rowData, setrowData] = React.useState(null);
    const gpuNameOptions = useSelector((store) =>
        store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
          .GPU !== undefined
          ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
            .GPU
          : null
      );
    
    const [sortConfig, setSortConfig] = useState({ column: null, order: 'asc' });
    const gpuWiseRegionData = useSelector(store => store.GPUData.gpuWiseRegionData !== undefined ? store.GPUData.gpuWiseRegionData : []);
    const requestStateOption = useSelector((store) =>
        store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
          .RequestStatus !== undefined
          ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
          .RequestStatus
          : null
      );
    const [previousDatasOfSelectedRows, setPreviousDatasOfSelectedRows] = React.useState([]);
    const tableDataReducer = useSelector((state) => state.tableData.tableData);
    

    const handleSort = (column) => {
        let order = 'asc';
        if (sortConfig.column === column && sortConfig.order === 'asc') {
            order = 'desc';
        }
        setSortConfig({ column, order });
    };
    const allRI = useSelector((store) =>
        store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
        .RI !== undefined
        ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
        .RI?.map((item) => ({
            Value: item["Value"]
        }))
        : []
    );
    const getDateValue = (dateString) => {
        if (!dateString) return null;
        const [month, day, year] = dateString.split('/').map(Number);
        const dateObject = new Date(year, month - 1, day);
        return dateObject.getTime();
    };
    const sortedTableData = () => { 
    const { column, order } = sortConfig;
    if (column) {
        return [...props.tableData]?.sort((a, b) => {
            const valueA = a[column];
            const valueB = b[column];

            // Handling Date columns
            if (column.includes("Date")) {
                const dateA = getDateValue(valueA);
                const dateB = getDateValue(valueB);
                return order === 'asc' ? dateA - dateB : dateB - dateA;
            }

            // Treat `NA`, undefined, or null as the smallest or largest depending on the order
            const isNAorNullA = valueA === undefined || valueA === null || valueA === 'NA' ;
            const isNAorNullB = valueB === undefined || valueB === null || valueB === 'NA';

            if (isNAorNullA && isNAorNullB) {
                return 0; // If both are NA or null, no sorting needed
            }
            if (isNAorNullA) {
                return order === 'asc' ? -1 : 1; // `NA` should be at the top in ascending, bottom in descending
            }
            if (isNAorNullB) {
                return order === 'asc' ? 1 : -1; // `NA` should be at the top in ascending, bottom in descending
            }

            // If both are numbers, compare numerically
            if (!isNaN(valueA) && !isNaN(valueB)) {
                return order === 'asc' ? valueA - valueB : valueB - valueA;
            }

            // If both are strings, compare alphabetically
            const comparison = valueA.localeCompare(valueB);
            return order === 'asc' ? comparison : -comparison;
        });
    }

    // If no column specified, return the data unchanged
    return order === 'asc' ? props.tableData : props.tableData.slice()?.reverse();
};


    const openEdit = (row) => {
        setOpenEditModal(true);
        setShowBackDrop(true);
        setrowData(row)
    }

    const closeConfirmationModal = () => {
        setOpenEditModal(false);
        setShowBackDrop(false)
    }

    const handleRowSelect = (rowIndex, flag) => {
        const shallowCopyValues = previousDatasOfSelectedRows?.find(item => item.RequestID === rowIndex);
            let oldValues = shallowCopyValues ? JSON.parse(JSON.stringify(shallowCopyValues)) : "";
            if (flag) {
                return oldValues ? oldValues : ""
            }
            setSelectedRows((prevSelectedRows) => {
                let updatedSelectedRows;
                if (prevSelectedRows?.includes(rowIndex)) {
                    let changedRow = JSON.parse(JSON.stringify(tableDataReducer)).find(item => item.RequestID === rowIndex) 
                    if (changedRow['GPUsAllocated'] !== oldValues['GPUsAllocated'] || changedRow['RequestStatus'] !== oldValues['RequestStatus'] || changedRow['GPU_Name'] !== oldValues['GPU_Name'] || changedRow['DC_RegionAllocated'] !== oldValues['DC_RegionAllocated'] ) {
                    dispatch(
                        handleManualAllocation({
                          oldObject: changedRow,
                          newObject: oldValues,
                        })
                      )

                }
                    updatedSelectedRows = prevSelectedRows.filter((row) => row !== rowIndex);
                    setSelectedRows(updatedSelectedRows)
                    const newTableData = []
                    tableDataReducer?.map(item => {
                        if (item.RequestID === rowIndex) {
                            newTableData.push(oldValues)
                        } else {
                            newTableData.push(item)
                        }
                    })
                    dispatch(updateAllManagedTableData(newTableData)); // do updatation for respective tabledata data
                } else {
                    updatedSelectedRows = [...prevSelectedRows, rowIndex];
                    const oldValue = JSON.parse(JSON.stringify(props.tableData?.find(item => item.RequestID === rowIndex)));
                    setPreviousDatasOfSelectedRows([...previousDatasOfSelectedRows, oldValue])
                    if (flag) {
                        return oldValues
                    }
                }
                props.handleSelectedIndex(updatedSelectedRows);
                return updatedSelectedRows;
            });
        
    };

    const handleSelectAll = () => {
        let selectAll = props.selectAll;
        if (selectAll) {
            setSelectedRows([]);
            props.handleSelectedIndex([]);
        } else {
            const oldTableValue = JSON.parse(JSON.stringify(props.tableData));
            setPreviousDatasOfSelectedRows([...oldTableValue]);
                setSelectedRows(props.tableData.map(item => item.RequestID));
                props.handleSelectedIndex(props.tableData.map(item => item.RequestID));           
        }
        props.setSelectAllChange(!selectAll);
    };


    function formatDateForDefaultDateValue(dateString) {
        if(dateString){
            const parts = dateString.split('/');
        if (parts.length === 3) {
            const [month, day, year] = parts;
            return `${year}-${month}-${day}`;
        }
        return ''; 
        }
        return ''; 
    }
 
    const hasContributor = sessionStorage.getItem("ActiveRole")?.includes('Contributor');
    useEffect(() => {
        if(Object.keys(errorRow).length === 0){            
            props.setIsRaedyForUpdate(true)
        }else{
            props.setIsRaedyForUpdate(false)
        }
    },[errorRow])
    const setInputField = (rowIndex, label, row) => {
        let index = props.tableData?.findIndex(item => item.RequestID === rowIndex)
        let currentGPURegionData = [];
        
        let selectedIndex =tableDataReducer.filter(item => item.RequestID === rowIndex);
        currentGPURegionData = gpuWiseRegionData[selectedIndex[0].GPU_Name];

        const validate_GPU_Granted = (value, selectedRegion) => {
            if(!selectedIndex[0]['GPU_Name']){
                setErrorRow({...errorRow, [rowIndex]: "Please select a GPU"}) 

            }else if(!selectedRegion){
                setErrorRow({...errorRow, [rowIndex]: "Please select a Region"}) 

            }else if(parseInt(value) < 0){
                setErrorRow({...errorRow, [rowIndex]: "GPU Granted cannot be negative"}) 
            }else  if(parseInt(value) !== 0 && parseInt(value) % 8 !==0  && value!==""){
                setErrorRow({...errorRow, [rowIndex]: "Value must be a multiple of 8"}) 

            }else{
                let updatedErrorRow = { ...errorRow };
                delete updatedErrorRow[rowIndex];
                setErrorRow(updatedErrorRow);

            }
        }
            

        if (label === 'DC_RegionAllocated') {
            return (
              <div
                key={rowIndex}
                className="input-container master-table-input"
              >
                <select
                  className="select-container-table"
                  style={{ color: "black" }}
                  onChange={(event) => {
                      props.handletableChange(
                          event,
                          rowIndex,
                          "DC_RegionAllocated",
                          label
                        );
                        if(event.target.value !== ""){

                                validate_GPU_Granted(selectedIndex[0].GPUsAllocated, event.target.value)
    
                        }
                  }}
                  defaultValue={selectedIndex[0]["DC_RegionAllocated"]}
                  id={
                    label === "DC_RegionAllocated"
                      ? `DC_RegionAllocated_${rowIndex}`
                      : undefined
                  }
                >
                        <option value="" selected={selectedIndex[0]["DC_RegionAllocated"] === ""} disabled={true}>
                        Choose Region
                        </option>
                  {currentGPURegionData?.map((item) => (
                    <option value={item}>{item}</option>
                  ))}
                </select>
              </div>
            );
        }
        else if (label === 'GPUsAllocated') {
            return (
              <div
                key={rowIndex}
                className="input-container master-table-input master-gpu"
              >
                <div>
                  <input
                    type="number"
                    className="custom-input-table"
                    style={{ outline: "none", width: 150 }}
                    value={(selectedIndex[0].GPUsAllocated || "")}
                    onWheel={(e) => e.target.blur()}
                    id={
                      label === "GPUsAllocated"
                        ? `GPUsAllocated_${rowIndex}`
                        : undefined
                    }
                    onChange={(event) => {
                      if (!selectedIndex[0]["GPU_Name"]) {
                      
                        setErrorRow({
                          ...errorRow,
                          [rowIndex]: "Please select a GPU",
                        });
                      } else if (!selectedIndex[0].DC_RegionAllocated) {
                        setErrorRow({
                          ...errorRow,
                          [rowIndex]: "Please select a Region",
                        });
                      } else if (parseInt(event.target.value) < 0) {
                        setErrorRow({
                          ...errorRow,
                          [rowIndex]: "GPU Granted cannot be negative",
                        });
                      } else if (
                        parseInt(event.target.value) !== 0 &&
                        event.target.value !== "" &&
                        parseInt(event.target.value) % 8 !== 0
                    ) {
                        setErrorRow({
                          ...errorRow,
                          [rowIndex]: "Value must be a multiple of 8",
                        });
                        props.handletableChange(event, rowIndex, label, row);
                      } else {
                        let updatedErrorRow = { ...errorRow };
                        delete updatedErrorRow[rowIndex];
                        setErrorRow(updatedErrorRow);
                        props.handletableChange(event, rowIndex, label, row);

                      }
                    }}
                    min={0}
                  />
                  {Object.keys(errorRow).includes(rowIndex.toString()) && (
                    <>
                      <div style={{ color: "red", fontSize: "9px" }}>
                        {errorRow[rowIndex]}
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
        }
        else if (label === 'EarmarkedDate' || label === "FullyAllocatedDate" ) {
            return (
                <div key={rowIndex} className="input-container master-table-input">
                    <input
                        type="date"
                        className="custom-input-table"
                        placeholder="Enter Date"
                        onKeyDown={(event) => event.preventDefault()}
                        defaultValue={formatDateForDefaultDateValue(selectedIndex[0][label])}
                        onChange={(event) => { props.handletableChange(event, rowIndex, label) }}
                    />
                </div>
            );
        }
        else if (label === 'RequestStatus') {
            return (
                <div key={rowIndex} className="input-container">
                    <select
                        className="select-container-table"
                        onChange={(event) => { props.handletableChange(event, rowIndex, 'RequestStatus') }}
                        defaultValue={selectedIndex[0]['RequestStatus']}
                        style={{ color: 'black' }}
                    >
                        {requestStateOption?.map((item, index) => (
                            <option key={index} style={{ color: 'black' }} value={item['Value']}>{item['Value']}</option>
                        ))}
                    </select>
                </div>
            )
        }
        else if (label === 'RI') {
             return (
                <div key={rowIndex} className="input-container">
                    <select
                        className="select-container-table"
                        onChange={(event) => { props.handletableChange(event, rowIndex, 'RI') }}
                        defaultValue={selectedIndex[0]['RI'] || ""}
                        style={{ color: 'black' }}
                    >                        
                    <option value="" disabled={true}>Choose RI</option>
                        {allRI?.map((item, index) => (
                            <option key={index} style={{ color: 'black' }} value={item['Value']}>{item['Value']}</option>
                        ))}
                    </select>
                </div>
            )
        }
        else if (label === 'GPU_Name') {
            return (
                <div key={rowIndex} className="input-container master-table-input ">
                    <select
                        className="select-container-table"
                        onChange={(event) => { props.handletableChange(event, rowIndex, 'GPU_Name'); }}
                        defaultValue={props.tableData[index]['GPU_Name']}
                        style={{ color: 'black' }}
                    >
                        <option value="" disabled={true}>-- Select GPU --</option>
                        {gpuNameOptions?.map((item) => (
                            <option value={item["Value"]}>{item["Value"]}</option>
                        ))}
                    </select>
                </div>
            )
        }
        else {
            return (
                <div key={rowIndex} className="input-container master-table-input">
                    <input
                        type="text"
                        className="custom-input-table"
                        placeholder={`Enter ${label}`}
                        onChange={(event) => { props.handletableChange(event, rowIndex, label) }}
                    />
                </div>
            )
        }
    }

    const getCellStyle = (row, label,) => {
        const isSelected = selectedRows.includes(row.RequestID) || selectedRows.includes(row.RowID);
        const maxWidth = (["GPU_Name", "RequestStatus", "CustomerName", "MicrosoftOwnerEmail", "CustomerEmail", "Region", "DateAllocated", "DC_RegionAllocated", "GPUsAllocated", "SubscriptionID", "GetHelpID"].includes(label) || label.includes("Date"))
            ? "fit-content"
            : (["RI", "AIGBB", "UAT_ID", "Tag", "Notes", "TPID"].includes(label)
                ? (selectedRows && props.capacityAllocation ? "12vw" : "10vw")
                : "2vw");
        const minWidth = ["RI","Tag", "AIGBB"].includes(label) 
        ? (selectedRows && props.capacityAllocation ? '10vw' : '')
            : (label === 'RegionRequested' ? '10vw' : '');
        const customerStyle = label === 'CustomerName'
            ? (hasContributor ? customerColumn : { ...customerColumn, ...basicCustomer })
            : {};
    
        return {
            ...bodyStyle,
            backgroundColor: isSelected ? '#ccd8e0' : '',
            maxWidth,
            minWidth,
            ...customerStyle
        };
    };
    const getCellTitle = (row, label) => {
        const getValue = (key) => row[key] && row[key] !== -1 && row[key] !== '-1' ? `"${row[key]}"` : 'NA';
        
        return `ID: ${getValue('RequestCode')}\nCustomer Name: ${getValue('CustomerName')}\nGPU: ${getValue('GPU_Name')}\n${
            label !== 'GPU_Name' && label !== 'CustomerName' && label !== 'RequestCode'
            ? `${label}: ${getValue(label)}`
            : ''
        }`;
    };
  
    return (
        <> <Draggable  showScroll={true}>
            <table className='master-table ' style={{ borderSpacing: '0px'}}>
                <thead>
                    <tr style={tableheader}>
                        <th className='tableTD' style={{ maxWidth: '100px', position: 'sticky !important', top: 0, zIndex: 1 }}>
                            <input
                                type="checkbox"
                                checked={props.selectAll}
                                onChange={handleSelectAll}
                            />
                        </th>
                        { tableFormat.headerLabels.length > 0 && tableFormat.headerLabels.map((label, index) => (
                            <th key={index} style={{ ...headerStyle, position: 'sticky !important', top: 0, zIndex: 1 }}
                                onClick={() => {
                                    handleSort(tableFormat.keys[index]);
                                }}>
                                {label === 'Request Granted Status' ? 'Request Granted' : label}
                                {sortConfig.column ===tableFormat.keys[index] && (
                                    <span style={{ marginLeft: '10px' }}>
                                {sortConfig.order === 'asc' ? '▲' : '▼'}
                                </span>
                            )}
                            </th>
                        ))}
                    </tr>
                </thead>
                {!props.tableLoader &&
                    <tbody>
                        {sortedTableData()?.map((row, rowIndex) => (
                            <tr
                                key={rowIndex}
                                style={{
                                    backgroundColor: selectedRows?.includes(rowIndex) || selectedRows?.includes(row.RowID) ? '#f6f6f6' : '#f6f6f6',
                                }}
                            >
                                <td className='tableTD' style={{ backgroundColor: selectedRows.includes(row.RequestID) || selectedRows?.includes(row.RowID) ? '#ccd8e0' : '#f6f6f6' }}>
                                    <input
                                        type="checkbox"
                                        checked={props.selectedIndex?.includes(row.RequestID) || selectedRows?.includes(row.RowID)}
                                        onChange={() => { handleRowSelect(row.RequestID, false); if (props.rowErrors !== '') { props.rowErrors[rowIndex] = '' } }}
                                    />
                                </td>


                                {tableFormat.keys.length > 0 && tableFormat.keys.map((label, columnIndex) =>

                                (

                                    <td
                                        key={columnIndex}
                                        style={getCellStyle(row, label)}                                        
                                        title={getCellTitle(row, label)}
                                    >

                                        {(() => {
                                            const isSpecialLabel = ['RequestStatus', 'DC_RegionAllocated', 'GPUsAllocated', 'GPU_Name', 'EarmarkedDate', 'RI', 'FullyAllocatedDate', 'AIGBB'].includes(label);
                                            const isRowSelected = selectedRows.includes(row.RequestID) || selectedRows.includes(row.RowID);
                                            if (label === 'RequestID') {
                                                return row['RequestCode'] && row['RequestCode'] !== -1 && row['RequestCode'] !== '-1'
                                                    ? <span>{row['RequestCode']}</span>
                                                    : <span>NA</span>;
                                            }

                                            if (isSpecialLabel && props.capacityAllocation) {
                                                return isRowSelected
                                                    ? setInputField(row.RequestID, label, row.DC_RegionAllocated)
                                                    : ((row[label] && row[label] !== -1 && row[label] !== '-1' || ( (['GPUsAllocated', 'GPUsRequested', 'GPUsOwed'].includes(label))))
                                                        ? <span onClick={() => label === 'CustomerName' && openEdit(row)}>{row[label]}</span> 
                                                        : <span onClick={() => label === 'CustomerName' && hasContributor && openEdit(row)}>NA</span>);
                                            }

                                    

                                            return ((row[label] && row[label] !== -1 && row[label] !== '-1') || (['GPUsAllocated', 'GPUsRequested', 'GPUsOwed'].includes(label))
                                                ? <span
                                                    onClick={() => {
                                                        if (label === 'CustomerName' && hasContributor) {
                                                            openEdit( row);
                                                        }  
                                                    }}
                                                >
                                                    {row[label]}
                                                </span>
                                                : <span onClick={() => label === 'CustomerName' && hasContributor && openEdit(row)}>NA</span>
                                            );
                                        })()}

                                        {props.rowErrors[rowIndex] && props.errorLabel === label ? (
                                            <div className="error-message" style={{ color: 'red', fontSize: '8px', whiteSpace: 'initial', lineHeight: '12px' }}>
                                                {props.rowErrors[rowIndex]}
                                            </div>
                                        ) : ''}

                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                }
            </table>
        </Draggable>

            {props.tableLoader &&
                <div className="loader-container">
                    <div className="loader"></div>
                </div>
            }

            {showBackDrop && <div className="modal-backdrop"></div>}
            {openEditModal ? <Detail
                closeConfirmationModal={closeConfirmationModal}
                data={rowData}
                handletableInputChange={props.handletableChange}
            ></Detail> : ''}

        </>
    );
};

const headerStyle = {
    lineHeight: '20px',
    letterSpacing: '0px',
    textAlign: 'left',
    height: '30px',
    padding: '10px',
    maxWidth: 'auto'
};

const bodyStyle = {
    lineHeight: '16px',
    letterSpacing: '0px',
    textAlign: 'left',
    height: '30px',
    padding: '10px',
    minWidth: "4vw"
};
const tableheader = {
    position: 'sticky',
    top: 0,
    backgroundColor: '#fff',
    zIndex:1
}

const customerColumn = {
    width: 'fit-content',
    color: '#005a9e',
    textDecoration: 'underline',
    cursor: 'pointer'
}
const basicCustomer = {
    cursor: 'default',
    textDecoration: 'none',
    color: 'none'
  
}
export default AddComponent;